import { render, staticRenderFns } from "./NewAddressDialog.vue?vue&type=template&id=51d05820&scoped=true"
import script from "./NewAddressDialog.vue?vue&type=script&lang=js"
export * from "./NewAddressDialog.vue?vue&type=script&lang=js"
import style0 from "./NewAddressDialog.vue?vue&type=style&index=0&id=51d05820&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d05820",
  null
  
)

export default component.exports